import styled from "styled-components";
import Colors from "../../../assets/Colors";

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  max-width: 100vw;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 10px;
  overflow-x: auto;
  @media (max-width: 768px) {
    overflow-x: scroll;
  }
`;

const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 36fr 23fr 24fr 17fr;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
  min-width: ${(props) => (props.widthProp ? props.widthProp : "100%")};
`;

const TableCell = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_secondary};
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
`;

const InsideCell = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  max-width: 100%;
`;

const divInsideCell = styled.div`
  font-size: 12px;
  font-weight: 300;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 70%;
  @media (max-width: 768px) {
    margin-right: 5px;
  }
`;

const ImageContainer = styled.img`
  border-radius: 5px;
  height: 34px;
  width: 34px;
  margin-right: 11px;
  min-width: 34px;
`;

const RowWrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: ${(props) => `${props.columns + 1}`};
  grid-template-columns: ${(props) => `${props.grid}`};
  display: grid;
  border-left: 3px solid transparent;
  padding-left: -3px;
  &:hover {
    background: ${Colors.primary}10;
    border-left: 3px solid ${Colors.primary};
  }
`;

const Line = styled.div`
  grid-column-start: 1;
  grid-column-end: ${(props) => `${props.columns + 1}`};
  height: 1px;
  border-bottom: 1px solid ${Colors.line_separator};
  width: 100%;
`;

const NoItemsContainer = styled.div`
  height: 144px;
  display: grid;
  align-items: center;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

export default {
  Container,
  TableContainer,
  TableCell,
  ImageContainer,
  Line,
  NoItemsContainer,
  NoItemsMessageCenter,
  InsideCell,
  RowWrapper,
  divInsideCell,
};
